import React, { useState } from "react";


import {
  Button,
  Card,
  CardBody,
  Content,
  Divider,
  Grid,
  GridItem,
  List,
  ListItem,
  Modal,
  ModalBody,
  ModalHeader,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";


import {
  ExternalLinkAltIcon
} from "@patternfly/react-icons";


import {
  candidateApplicationDocuments,
  candidateRecruitment,
  candidateRecruitmentDocuments,
  candidateSupportDocuments
} from "./data/candidateDocuments";


import {
  candidatePosters
} from "./data/candidatePosters";


const DocumentList = ({ documents }) => (
  <Content>
    <List isPlain>
      {documents.map((document) => (
        <ListItem key={document.id}>
          <a
            href={document.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {document.title}{" "}
            <ExternalLinkAltIcon />
          </a>
        </ListItem>
      ))}
    </List>
  </Content>
);


const PosterCard = ({
  poster,
  onOpen
}) => {
  return (
    <Card isFullHeight>
      <CardBody>
        <Button
          variant="plain"
          onClick={() => onOpen(poster)}
          aria-label={`Powiększ plakat: ${poster.title}`}
          style={{
            width: "100%"
          }}
        >
          <img
            src={poster.src}
            alt={poster.title}
            style={{
              display: "block",
              width: "100%",
              height: "auto"
            }}
          />
        </Button>
      </CardBody>
    </Card>
  );
};


const CandidatePage = () => {
  const [selectedPoster, setSelectedPoster] = useState(null);


  const handlePosterOpen = (poster) => {
    setSelectedPoster(poster);
  };


  const handlePosterClose = () => {
    setSelectedPoster(null);
  };


  return (
    <>
      <PageSection isWidthLimited>
        <Stack hasGutter>
          <StackItem>
            <Grid>
              <GridItem span={12} md={8} mdOffset={2}>
                <Content style={{ textAlign: "center" }}>
                  <h1>Dla kandydata</h1>

                  <p>
                    Informacje, dokumenty i zasady rekrutacji do szkoły.
                  </p>
                </Content>
              </GridItem>
            </Grid>
          </StackItem>


          <StackItem>
            <Grid hasGutter>
              <GridItem span={12} lg={4}>
                <Card isFullHeight isGlass>
                  <CardBody>
                    <Stack hasGutter>
                      <StackItem>
                        <Content>
                          <h2>
                            Rekrutacja {candidateRecruitment.schoolYear}
                          </h2>

                          <p>
                            Drodzy Ósmoklasiści!
                          </p>

                          <p>
                            Rekrutacja prowadzona jest za pomocą
                            elektronicznego systemu rekrutacji.
                          </p>
                        </Content>
                      </StackItem>

                      <StackItem>
                        <Content>
                          <strong>Termin rekrutacji</strong>

                          <p>
                            {candidateRecruitment.startDate}
                            {" – "}
                            {candidateRecruitment.endDate}
                          </p>
                        </Content>
                      </StackItem>

                      <StackItem>
                        <Button
                          component="a"
                          variant="primary"
                          href={candidateRecruitment.recruitmentUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          icon={<ExternalLinkAltIcon />}
                          iconPosition="end"
                        >
                          Przejdź do systemu rekrutacji
                        </Button>
                      </StackItem>

                      <StackItem>
                        <Content>
                          <p>
                            Zapraszamy i czekamy na Was.
                          </p>
                        </Content>
                      </StackItem>
                    </Stack>
                  </CardBody>
                </Card>
              </GridItem>


              <GridItem span={12} lg={4}>
                <Card isFullHeight isGlass>
                  <CardBody>
                    <Stack hasGutter>
                      <StackItem>
                        <Content>
                          <h2>Podania i zaświadczenia</h2>
                        </Content>
                      </StackItem>

                      <StackItem>
                        <DocumentList
                          documents={candidateApplicationDocuments}
                        />
                      </StackItem>

                      <StackItem>
                        <Divider />
                      </StackItem>

                      <StackItem>
                        <Content>
                          <h3>
                            Pomoc psychologiczno-pedagogiczna
                          </h3>
                        </Content>
                      </StackItem>

                      <StackItem>
                        <DocumentList
                          documents={candidateSupportDocuments}
                        />
                      </StackItem>
                    </Stack>
                  </CardBody>
                </Card>
              </GridItem>


              <GridItem span={12} lg={4}>
                <Card isFullHeight isGlass>
                  <CardBody>
                    <Stack hasGutter>
                      <StackItem>
                        <Content>
                          <h2>Zasady rekrutacji</h2>
                        </Content>
                      </StackItem>

                      <StackItem>
                        <DocumentList
                          documents={candidateRecruitmentDocuments}
                        />
                      </StackItem>
                    </Stack>
                  </CardBody>
                </Card>
              </GridItem>
            </Grid>
          </StackItem>


          <StackItem>
            <Content style={{ textAlign: "center" }}>
              <h2>Materiały promocyjne</h2>
            </Content>
          </StackItem>


          <StackItem>
            <Stack hasGutter>
              <StackItem>
                <Grid hasGutter>
                  {candidatePosters
                    .slice(0, 3)
                    .map((poster) => (
                      <GridItem
                        key={poster.id}
                        span={12}
                        sm={6}
                        lg={4}
                      >
                        <PosterCard
                          poster={poster}
                          onOpen={handlePosterOpen}
                        />
                      </GridItem>
                    ))}
                </Grid>
              </StackItem>


              <StackItem>
                <Grid hasGutter>
                  {candidatePosters
                    .slice(3)
                    .map((poster, index) => (
                      <GridItem
                        key={poster.id}
                        span={12}
                        sm={6}
                        lg={4}
                        lgOffset={index === 0 ? 2 : undefined}
                      >
                        <PosterCard
                          poster={poster}
                          onOpen={handlePosterOpen}
                        />
                      </GridItem>
                    ))}
                </Grid>
              </StackItem>
            </Stack>
          </StackItem>
        </Stack>
      </PageSection>
      <Modal
        isOpen={Boolean(selectedPoster)}
        onClose={handlePosterClose}
        variant="large"
        appendTo={() => document.body}
      >
        <ModalHeader title={selectedPoster?.title} />

        <ModalBody
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden"
          }}
        >
          {selectedPoster && (
            <img
              src={selectedPoster.src}
              alt={selectedPoster.title}
              style={{
                display: "block",
                width: "auto",
                maxWidth: "100%",
                height: "auto",
                maxHeight: "calc(100dvh - 10rem)",
                objectFit: "contain"
              }}
            />
          )}
        </ModalBody>
      </Modal>
    </>
  );
};


export default CandidatePage;